import React, {memo} from "react";
import Sidebar from "./Sidebar/Sidebar";
import Card from "./Card";
import { useSelector} from "react-redux";
import {RootState} from "../store";
import ProfilePanel from "./Sidebar/ProfilePanel";

interface PageBlockInterface {
    children: JSX.Element | React.ReactNode
}

const PageBlock = ({children}: PageBlockInterface) => {
    const isSidebarMinimized = useSelector((state: RootState) => state.sidebar.isMini);

    return (
        <div className={`w-full h-full lg:flex lg:justify-between ${isSidebarMinimized ? 'lg-close-menu' : ''} mt-[0.25rem]`}>
            <div className={`${isSidebarMinimized ? 'lg:max-w-[68px]' : 'hidden lg:block lg:max-w-[320px]'} w-full`}>
                <Card
                    className={`${isSidebarMinimized ? 'h-[calc(100vh-0.5rem)] transition-all duration-500' : (!isSidebarMinimized ? 'h-16 transition-all duration-500 w-full lg:max-w-[320px]' : 'h-16 transition-all duration-500 lg:max-w-[68px]')} sidebar-menu 3xl:px-4 4xl:px-8 top-0 left-0 lg:top-[0.25rem!important] lg:left-[0.25rem!important] col-span-1 shadow-xl shadow-blue-gray-900/5 dark:bg-blue-gray-900 dark:text-white rounded-none lg:rounded-xl z-10 lg:fixed`}>
                    <Sidebar/>
                </Card>
            </div>
            <div
                className={`${!isSidebarMinimized ? 'lg:max-w-[calc(100%-326px)]' : 'lg:max-w-[calc(100%-74px)]'} px-2 lg:px-4 w-full`}>
                <ProfilePanel />
                <div className="mx-2">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default memo(PageBlock);
